// extracted by mini-css-extract-plugin
export default {"modalFooter":"DeleteSectionModal__modalFooter___JXADg"};